(function () {
    const head = document.querySelector('.gh-head');
    if (!head) return;

    const items = document.querySelectorAll('.aleph-nav .nav-item[data-mega-key]');
    const panels = document.querySelectorAll('.nav-mega');
    let closeTimer;

    const resetPanel = function (panel) {
        const defaultScope = panel.getAttribute('data-mega');
        panel.querySelectorAll('[data-mega-scope]').forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('data-mega-scope') === defaultScope);
        });
        panel.querySelectorAll('.nav-mega-posts-scope').forEach(function (scope) {
            scope.hidden = scope.getAttribute('data-scope') !== defaultScope;
        });
    };

    // Desktop-only feature (see the matching @media(min-width:1101px) gate
    // in screen.css -- moved from 992px since the 10-category row wraps to
    // 2 lines at any width ≤1075px, e.g. iPad Pro portrait's 1024px)
    // -- guarded here too so a touch tap's synthetic focus/mouseenter
    // never sets the attribute in the first place on mobile, rather than
    // relying solely on the CSS to hide the result.
    const isDesktopNav = window.matchMedia('(min-width: 1101px)');

    const open = function (key) {
        if (!isDesktopNav.matches) return;
        clearTimeout(closeTimer);
        head.setAttribute('data-mega-open', key);
    };

    const scheduleClose = function () {
        clearTimeout(closeTimer);
        closeTimer = setTimeout(function () {
            head.removeAttribute('data-mega-open');
            panels.forEach(resetPanel);
        }, 200);
    };

    const showScope = function (panel, scope) {
        panel.querySelectorAll('[data-mega-scope]').forEach(function (link) {
            link.classList.toggle('is-active', link.getAttribute('data-mega-scope') === scope);
        });
        panel.querySelectorAll('.nav-mega-posts-scope').forEach(function (el) {
            el.hidden = el.getAttribute('data-scope') !== scope;
        });
    };

    items.forEach(function (item) {
        const key = item.getAttribute('data-mega-key');
        item.addEventListener('mouseenter', function () { open(key); });
        item.addEventListener('mouseleave', scheduleClose);
        item.addEventListener('focusin', function () { open(key); });
    });

    panels.forEach(function (panel) {
        panel.addEventListener('mouseenter', function () {
            clearTimeout(closeTimer);
            head.setAttribute('data-mega-open', panel.getAttribute('data-mega'));
        });
        panel.addEventListener('mouseleave', scheduleClose);

        panel.querySelectorAll('[data-mega-scope]').forEach(function (link) {
            link.addEventListener('mouseenter', function () {
                showScope(panel, link.getAttribute('data-mega-scope'));
            });
            link.addEventListener('focus', function () {
                showScope(panel, link.getAttribute('data-mega-scope'));
            });
        });
    });

    head.addEventListener('focusout', function (e) {
        if (!head.contains(e.relatedTarget)) {
            head.removeAttribute('data-mega-open');
            panels.forEach(resetPanel);
        }
    });

    document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
            head.removeAttribute('data-mega-open');
            panels.forEach(resetPanel);
        }
    });
})();
